import { STATE_ABBR_TO_NAME } from '@/utils/consts/city/city-abbr-to-name.const';
import { City } from '@/types/city.type';

export async function getCitySlug(city: string, state: string): Promise<City | null> {
  if (!STATE_ABBR_TO_NAME[state]) {
    return null;
  }

  const citiesFromStateModule = await import(`@/utils/consts/city/city-by-state/${state.toLowerCase()}`);

  const cities: City[] = citiesFromStateModule[`ALL_CITIES_${state}`];
  if (!cities) {
    return null;
  }

  const selectedCity = cities.find((value) => {
    return value?.city?.toLocaleLowerCase() === city.toLocaleLowerCase();
  });

  return selectedCity ?? null;
}
